import { useState } from "react";

const faqs = [
  {
    q: "How do I get an expedited passport in Aberdeen, South Dakota?",
    a: "Aberdeen residents can use Fast Passport Center for 2–9 day expedited processing. Submit your application, visit a local acceptance facility, then ship your documents to us overnight. We handle the agency submission — no trip to Minneapolis required.",
  },
  {
    q: "Where is the nearest passport agency to Aberdeen SD?",
    a: "The Minneapolis Passport Agency (212 3rd Ave S, Minneapolis, MN) is approximately 290 miles east of Aberdeen via I-29 and I-94. It requires an appointment for genuine emergencies only. Fast Passport Center eliminates that trip for most applicants.",
  },
  {
    q: "What is the fastest way to get a passport in Aberdeen SD?",
    a: "For true emergencies (travel within 72 hours), you may qualify for same-day processing via the Minneapolis agency. For most travelers, Fast Passport Center offers 2–9 day processing without requiring you to leave Aberdeen.",
  },
  {
    q: "Can I get a passport at the Aberdeen post office?",
    a: "Yes — the Aberdeen Main Post Office (317 S 1st St) serves as an acceptance facility. However, routine postal processing takes 6–11 weeks. Fast Passport Center can expedite this to 2–9 days using our registered courier submission.",
  },
  {
    q: "How long does passport renewal take for Aberdeen residents?",
    a: "Routine renewal via USPS takes 6–11 weeks from Aberdeen. Expedited via post office is 3–5 weeks. Fast Passport Center offers 2–9 business day processing using our registered courier submission channels.",
  },
  {
    q: "Does Aberdeen SD have a passport agency?",
    a: "Aberdeen does not have a regional passport agency. The nearest full-service agency is in Minneapolis, MN (290+ miles). Acceptance facilities (post offices, county clerk) can accept applications but cannot process them quickly.",
  },
  {
    q: "Can Northern State University students use your service?",
    a: "Absolutely. NSU students and faculty in Aberdeen are fully eligible for our expedited passport services. Whether it is study abroad, international research, or a faculty exchange program, we get your passport processed fast.",
  },
  {
    q: "Do you serve surrounding Brown County communities?",
    a: "Yes. We serve all of Brown County including Aberdeen, Groton, Ipswich, Leola, Eureka, and all surrounding northeastern South Dakota communities. Contact us with your location and we will walk you through the nearest acceptance facility.",
  },
];

export default function FAQSection() {
  const [open, setOpen] = useState<number | null>(null);

  return (
    <section id="faq" className="bg-white py-20 md:py-28">
      <div className="max-w-4xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">FAQ</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Frequently Asked Questions — Aberdeen SD Passports
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base">
            Everything Aberdeen residents ask about expedited passport services. Don&apos;t see your question? Call us directly.
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div key={i} className="border border-gray-200 rounded-lg overflow-hidden">
              <button
                onClick={() => setOpen(open === i ? null : i)}
                className="w-full flex items-center justify-between px-5 py-4 text-left hover:bg-[#F7F8FA] transition-colors"
              >
                <h4>
                  <a className="font-semibold text-[#1A365D] text-sm pr-4">{faq.q}</a>
                </h4>
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                  <i className={`${open === i ? "ri-subtract-line" : "ri-add-line"} text-[#1A365D] text-lg`}></i>
                </div>
              </button>
              {open === i && (
                <div className="px-5 pb-4">
                  <p className="text-gray-500 text-sm leading-relaxed">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}